import { render, staticRenderFns } from "./Prophecies.vue?vue&type=template&id=5b2d044c&scoped=true&"
import script from "./Prophecies.vue?vue&type=script&lang=js&"
export * from "./Prophecies.vue?vue&type=script&lang=js&"
import style0 from "./Prophecies.vue?vue&type=style&index=0&id=5b2d044c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d044c",
  null
  
)

export default component.exports